import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeUnit',
})
export class TimeUnitPipe implements PipeTransform {
  transform(value: 'days' | 'months' | null | undefined, args?: any): any {
    if (!value) {
      return '';
    }
    switch (value) {
      case 'days':
        return 'Tage';
      case 'months':
        return 'Monate';
      default:
        return '';
    }
  }
}
